<template>
  <Container type="card-full">
    <div>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="待结算" name="first">
          <div class="search">
            <div class="search_box">
              <div class="searchItem">
                <div class="label">项目编号</div>
                <div class="field">
                  <el-input
                    v-model.trim="query.projectcode"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="searchItem">
                <div class="label">项目名称</div>
                <div class="field">
                  <el-input
                    v-model.trim="query.projectname"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="searchItem">
                <div class="label">采购人</div>
                <div class="field">
                  <el-input v-model.trim="query.acomname" clearable></el-input>
                </div>
              </div>
              <div class="searchItem">
                <div class="label">业务员</div>
                <div class="field">
                  <el-input v-model.trim="query.ptcname" clearable></el-input>
                </div>
              </div>
              <div class="searchItem">
                <div class="label">项目员</div>
                <div class="field">
                  <el-input v-model.trim="query.cusername" clearable></el-input>
                </div>
              </div>
              <div class="searchItem">
                <div class="label">收款日</div>
                <div class="field" style="width: 400px">
                  <el-date-picker
                    v-model="query.startTime"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                  <div style="margin: 0 10px">至</div>
                  <el-date-picker
                    v-model="query.endTime"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="searchItem">
                <div class="search_btn">
                  <el-button type="primary" @click="search">查询</el-button>
                </div>
              </div>
            </div>
          </div>
          <vggrid
            :random="Math.floor(Math.random() * 999999)"
            :list="list"
            :defaultPage="15" 
            :total="query.count"
            ref="xGrid"
            tableheight="400"
            flexname=""
            :cols="cols"
            :showfooter="false"
            :showPage="true"
            @pagechange="pagechange"
            :resizable="true"
            @cellClick="cellClick"
            @cellDblClick="viewProject"
            :loading="loading"
          >
            <template slot="btn">
              <div style="display: flex; justify-content: space-between">
                <div>
                  <span
                    >共{{ query.count }}个项目，服务费合计{{
                      amt.fwfprice | Thousands
                    }}元</span
                  >
                </div>
                <div>
                  <el-button
                    type="primary"
                    size="small"
                    @click="itsmTableCountSelect"
                    ><i class="el-icon-finished"></i> 批量结算</el-button
                  >
                </div>
              </div>
            </template>
          </vggrid>
        </el-tab-pane>
        <el-tab-pane label="已结算" name="third">
          <settledXMYTab :activeName="activeName" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :title="projectRowMsg.projectcode + '-' + projectRowMsg.projectname"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <el-form
        class="small-space"
        :model="projectRowMsg"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="项目预算(元)" required>
          <span>{{ projectRowMsg.projectlimitamt }}</span>
        </el-form-item>
        <el-form-item label="服务费(元)" required>
          <span>{{ projectRowMsg.psuconfirmfeeamt }}</span>
        </el-form-item>
        <el-form-item label="结算金额(元)" required>
          <el-input
            @blur="inputMoney($event, 'psupmrewardmoney')"
            v-model="projectRowMsg.psupmrewardmoney"
            :maxlength="12"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSalerewardmoney">确 定</el-button>
      </span> </el-dialog
    ><el-dialog
      title="批量结算"
      :visible.sync="settlementInfo.batchEditFlg"
      width="60%"
      :before-close="handleClose"
    >
      <div class="radio">
        <div class="label">结算方式</div>
        <div class="values">
          <el-radio-group v-model="settlementInfo.settlementWay">
            <el-radio :label="1">按比例</el-radio>
            <el-radio :label="2">固定金额</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="radioCon">
        <div v-if="+settlementInfo.settlementWay === 1" class="radioRow">
          <div class="label">按比例</div>
          <div class="values" style="display: flex; align-items: center">
            <el-input
              v-model="settlementInfo.settlementPercentage"
              @input="validityPercentage"
              placeholder="请输入比例"
              style="width: 300px"
            >
              <template slot="append">%</template>
            </el-input>
            <span style="width: 200px; font-size: 13px; color: red">{{
              msg.msgPercentage
            }}</span>
          </div>
        </div>
        <div v-else class="radioRow">
          <div class="label">固定金额</div>
          <div class="values">
            <el-input
              v-model="settlementInfo.settlementAmount"
              @change="changeInputMoney"
              @input="validityMoney"
              placeholder="请输入结算价格"
              style="width: 300px"
            >
              <template slot="append">元</template>
            </el-input>
            <span style="width: 200px; font-size: 13px; color: red">{{
              msg.msgMoney
            }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settlementInfo.batchEditFlg = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="batchSaveSalerewardmoney"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import MenuBtn from "../common/menuBtn";
import settlementTab from "./settlementTab";
import vggrid from "../../views/common/vggrid";
import settledXMYTab from "./settledXMYTab";
import dayjs from "dayjs";
import { load } from "mime";
export default {
  name: "xmyjxjs",
  data() {
    return {
      menuid: this.$route.query.menuid,
      btnLoading: false,
      activeName: "first",
      dialogVisible: false,
      settlementInfo: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        isxmyOrywy: 2,
        settlementWay: 1,
        batchEditList: [],
        batchEditFlg: false,
        settlementPercentage: 0,
        settlementAmount: 0,
      },
      msg: {
        msgPercentage: "",
        msgMoney: "",
      },
      cols: [
        { type: "checkbox", width: 100, align: "center" },
        {
          field: "projectcode",
          fieldtype: "I",
          title: "项目编号",
          calculExpr: "",
        },
        {
          field: "projectname",
          fieldtype: "I",
          title: "项目名称",
          calculExpr: "",
        },
        {
          field: "Pcomname",
          fieldtype: "I",
          title: "采购人",
          calculExpr: "",
        },
        {
          field: "projectlimitamt",
          fieldtype: "I",
          title: "预算额（元）",
          calculExpr: "",
        },
        {
          field: "ptcusername",
          fieldtype: "I",
          title: "业务员",
          calculExpr: "",
        },
        {
          field: "pusername",
          fieldtype: "I",
          title: "项目员",
          calculExpr: "",
        },
        {
          field: "confirmfeeamt",
          fieldtype: "I",
          title: "服务费（元）",
          calculExpr: "",
        },
        {
          field: "projectreviewfeeCN",
          fieldtype: "I",
          title: "评审费",
          calculExpr: "",
        },
        {
          field: "psufewreceivetime",
          fieldtype: "I",
          title: "收取日",
          calculExpr: "",
        },
        {
          title: "操作 ",
          width: 100,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              return [
                <span
                  style="color:blue;cursor: pointer;"
                  onClick={this.settlementFu.bind(this, row)}
                  n
                >
                  结算
                </span>,
              ];
            },
          },
        },
      ],
      list: [],
      amt: {},
      projectRowMsg: {},
      query: {
        isMyself: 1,
        salerewardflg: 0,
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        total: 0,
        limit: 15,
        offset: 0,
      },
      loading: false
    };
  },
  async activated() {
    await this.getPerformance();
  },
  components: { MenuBtn, settlementTab, settledXMYTab, vggrid },
  created() {
    this.$on("CLOSE", () => this.close());
  },
  mounted() {},
  watch: {
    async activeName() {
      this.list = [];
      await this.getPerformance();
    },
  },
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    },
  },
  methods: {
    async pagechange (page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      await this.getPerformance();
    },
    search() {
      this.query.offset = 0
      this.query.limit = 15
      this.query.total = 0
      this.getPerformance();
    },
    async getPerformance() {
      this.loading = true
      this.query.endtTime_c = this.query.endTime
        ? dayjs(this.query.endTime).add(1, "day").format("YYYY-MM-D")
        : null;
      this.query.isMyself = 0;
      this.query.salerewardflg = 0;
      let res = await request({
        url: "/basic/statisticalAnalysis/getXMYPerformance",
        method: "get",
        params: this.query,
      });
      res.data.map((e) => {
        e.psupmrewardmoney = 0;
        e.psufewreceivetime = utils.formatterDate(
          e.psufewreceivetime,
          "yyyy-MM-dd"
        );
        e.projectlimitamt = utils.comdify(e.projectlimitamt);
        e.confirmfeeamt = utils.comdify(e.confirmfeeamt);
        e.projectreviewfeeCN = e.projectreviewfee === 1 ? '有' : '无';
        return e;
      });
      this.list = res.data;
      this.query.count = res.count[0].count;
      this.amt = res.amt;
      this.loading = false
    },
    async settlementFu(row) {
      this.projectRowMsg = row;
      this.dialogVisible = true;
    },
    async cellClick(row) {
      this.model = row;
    },
    async viewProject(row) {
      this.model = row;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async saveSalerewardmoney() {
      this.projectRowMsg.psupmrewardmoney = utils.delcommafy(
        this.projectRowMsg.psupmrewardmoney
      );
      let float = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
      if (
        this.projectRowMsg.psupmrewardmoney &&
        !float.test(this.projectRowMsg.psupmrewardmoney)
      ) {
        this.$message.warning("请输入正确的得分，只保留两位小数！");
        return;
      }
      this.$confirm("是否确定", "确认绩效", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/basic/statisticalAnalysis/saveXMYSalerewardmoney",
          method: "post",
          data: {
            query: this.query,
            projectRowMsg: this.projectRowMsg,
          },
        }).then((res) => {
          this.dialogVisible = false;
          this.getPerformance();
        });
      });
    },
    async itsmTableCountSelect() {
      this.settlementInfo.settlementPercentage = 0;
      this.settlementInfo.settlementAmount = 0;
      this.settlementInfo.batchEditList =
        this.$refs.xGrid.$refs.xGrid.getCheckboxRecords();

      if (this.settlementInfo.batchEditList.length === 0) {
        this.$message.warning("请选择结算项目");
        return;
      }
      this.settlementInfo.batchEditFlg = true;
    },
    changeInputMoney(e) {
      this.settlementInfo.settlementAmount = utils.comdify(e);
    },
    async batchSaveSalerewardmoney() {
      if (+this.settlementInfo.settlementWay === 2) {
        if (this.settlementInfo.settlementAmount === "") {
          this.$message.warning("金额不能为空");
          return;
        }
        this.settlementInfo.settlementAmount = utils.delcommafy(
          String(this.settlementInfo.settlementAmount)
        );
      } else {
        if (this.settlementInfo.settlementPercentage === "") {
          this.$message.warning("比例不能为空");
          return;
        }
        if (this.settlementInfo.settlementPercentage > 100) {
          this.$message.warning("比例不能大于100");
          return;
        }
      }
      this.$confirm("是否确定", "是否批量确认绩效", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await request({
          url: "/basic/statisticalAnalysis/batchSaveSalerewardmoney",
          method: "post",
          data: this.settlementInfo,
        });
        if (+res.issuccess === 1) {
          this.$message.success("结算成功");
          this.settlementInfo.batchEditFlg = false;
          await this.getPerformance();
        }
      });
    },
    validityMoney(e) {
      e = utils.delcommafy(e);
      this.settlementInfo.settlementAmount = e.replace(
        /^\D*(\d*(?:\.\d{0,2})?).*$/g,
        "$1"
      );
      // this.settlementInfo.settlementAmount = utils.comdify(e);
    },
    validityPercentage(e) {
      this.settlementInfo.settlementPercentage = e.replace(
        /^\D*(\d*(?:\.\d{0,2})?).*$/g,
        "$1"
      );
      if (e > 100) {
        this.msg.msgPercentage = "比例不能大于100";
      } else {
        this.msg.msgPercentage = "";
      }
    },
    inputMoney(el, name) {
      let float = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
      if (Number(el.target.value) && !float.test(el.target.value)) {
        this.$message.warning("请输入正确的得分，只保留两位小数！");
        return;
      }

      let val = utils.delcommafy(el.target.value);
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(val)) {
        this.projectRowMsg[name] = utils.getInputValue(el);
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.radio {
  display: flex;

  .label {
    margin: 20px;
  }
  .values {
    margin: 20px;
  }
}
.radioCon {
  .radioRow {
    margin: 20px;
    display: flex;
    align-items: center;
    .label {
      margin-right: 20px;
    }
    .values {
    }
  }
}
</style>
